import { render } from "./Lifeinsurance.vue?vue&type=template&id=21546ee1&scoped=true"
import script from "./Lifeinsurance.vue?vue&type=script&lang=js"
export * from "./Lifeinsurance.vue?vue&type=script&lang=js"

import "./Lifeinsurance.vue?vue&type=style&index=0&id=21546ee1&scoped=true&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21546ee1"]])

export default __exports__